export enum TxStatus {
  PENDING_APPROVE = 'PendingApprove',
  // SUBMITTED = 'Submitted',
  FAILED = 'Failed',
  PENDING_RECEIPT = 'PendingReceipt',
  SUCCESS = 'Success',
  REVERT = 'Revert',
}

export interface Tx {
  txHash: string
  description: string
  status: TxStatus
}
